import { useCallback, useRef, useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useMutation, useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { PageTitle } from '../../../../../_metronic/layout/core';
import ExcepcionGarantiaInfo from '../../../../Components/Garantias/ExcepcionGarantiaInfo';
import ConfirmWithLoaderV2 from '../../../../Components/Modals/ConfirmWithLoaderV2';
import { useGetUser } from '../../../../Hooks/CustomHooks';
import { GetGarantiaDetalleFullById, SaveExceptionReviewCobranza, SaveExceptionReviewTesoreria } from '../../../../api/Api';
import { EXCEPCION_GARANTIA_ESTADO, GARANTIA_ROL } from '../../../Utils/Constants';


export default function RevisionExcepcionGarantia() {
  const { id } = useParams();
  const user = useGetUser();

  const [showModalRevision, setShowModalRevision] = useState(false);
  const [isErrorSave, setIsErrorSave] = useState(false);
  const [isSuccessSave, setIsSuccessSave] = useState(false);
  const errorSaveMessage = useRef("");
  const [isApproved, setIsApproved] = useState(false);


  const {
    data: exceptionInfoQuery,
    isFetching: isFetchingExceptionInfo,
    refetch: refetchExceptionInfo
  } = useQuery(["initDataException", id], async ({ queryKey }) => {
    try {
      const id = queryKey[1];
      let result = null;
      result = await GetGarantiaDetalleFullById(id);
      return {
        garantia: result.data.garantia,
        detalleGarantia: result.data.detalle_garantia,
      };
    } catch (error) {
      console.log(error);
    }
  }, {
    enabled: !!id
  });

  const {
    mutate: mutateSaveExceptionReviewCobranza,
    isLoading: isFetchingSaveExceptionReviewCobranza,
  } = useMutation("saveExceptionReviewCobranza", SaveExceptionReviewCobranza, {
    onSuccess: (res) => {
      if (res?.success) {
        setIsSuccessSave(true);
        refetchExceptionInfo();
      } else {
        errorSaveMessage.current = res.message ? res.message : "Server error.";
        setIsErrorSave(true);
      }
    },
    onError: (err) => {
      errorSaveMessage.current = err.message;
      setIsErrorSave(true);
    },
  });

  const {
    mutate: mutateSaveExceptionReviewTesoreria,
    isLoading: isFetchingSaveExceptionReviewTesoreria,
  } = useMutation("saveExceptionReviewTesoreria", SaveExceptionReviewTesoreria, {
    onSuccess: (res) => {
      if (res?.success) {
        setIsSuccessSave(true);
        refetchExceptionInfo();
      } else {
        errorSaveMessage.current = res.message ? res.message : "Server error.";
        setIsErrorSave(true);
      }
    },
    onError: (err) => {
      errorSaveMessage.current = err.message;
      setIsErrorSave(true);
    },
  });


  const handleShowModalRevision = useCallback(() => {
    setShowModalRevision(true);
  },
    [],
  )

  const handleClose = useCallback(() => {
    setIsErrorSave(false);
    setIsSuccessSave(false);
  }, [])

  const handleConfirm = useCallback(() => {
    if (user.role.id === GARANTIA_ROL.REVISOR_COBRANZA) {
      mutateSaveExceptionReviewCobranza({
        idGarantiaRevision: exceptionInfoQuery?.detalleGarantia.excepcion.id_garantia_excepcion,
        estado: isApproved ? "APR" : "REC",
        updatedBy: user.email
      })
    }
    if (user.role.id === GARANTIA_ROL.REVISOR_TESORERIA) {
      mutateSaveExceptionReviewTesoreria({
        idGarantiaRevision: exceptionInfoQuery?.detalleGarantia.excepcion.id_garantia_excepcion,
        estado: isApproved ? "APR" : "REC",
        updatedBy: user.email
      })
    }
  }, [
    exceptionInfoQuery,
    isApproved,
    mutateSaveExceptionReviewCobranza,
    mutateSaveExceptionReviewTesoreria,
    user
  ])

  const isValidationButtonApprove = useCallback(() => {
    let isValid = false;
    if ([EXCEPCION_GARANTIA_ESTADO.INGRESADO.CODE, EXCEPCION_GARANTIA_ESTADO.PENDIENTE.CODE].includes(exceptionInfoQuery?.detalleGarantia.excepcion.codigo_estado_excepcion)) {
      isValid = true
    }
    return isValid;
  }, [exceptionInfoQuery])


  const breadcrumbs = [
    { title: "Inicio", path: "/dashboard", isActive: true, isSeparator: false },
    { title: "", path: "", isActive: false, isSeparator: true },
    { title: "Garantías", path: "", isActive: false, isSeparator: false },
    { title: "", path: "", isActive: false, isSeparator: true },
    { title: "Excepción de Garantías", path: "/garantias/listado_garantias_excepcion", isActive: false, isSeparator: false },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>Revision de Excepción</PageTitle>
      <div className="max-width-xl-900">
        <div className="row mb-3">
          <div className="col-7 container-action-secondary">
          </div>
          <div className="col-5 d-flex justify-content-end container-action-primary">
            <Button variant="primary"
              size='sm'
              onClick={handleShowModalRevision}
              disabled={isFetchingExceptionInfo || !isValidationButtonApprove()}
            >
              <i className="fi fi-rr-memo-circle-check fs-3"></i>  Aprobar / Rechazar
            </Button>
          </div>

        </div>
        <ExcepcionGarantiaInfo garantiaInfo={exceptionInfoQuery} isLoading={isFetchingExceptionInfo} ></ExcepcionGarantiaInfo>
      </div>


      <ConfirmWithLoaderV2
        showModal={showModalRevision}
        setShowModal={setShowModalRevision}
        title={"Aprobar / Rechazar Excepción"}
        isLoading={isFetchingSaveExceptionReviewCobranza || isFetchingSaveExceptionReviewTesoreria}
        isSuccess={isSuccessSave}
        isError={isErrorSave}
        textButton={"Guardar"}
        textButtonCancel={"Cerrar"}
        hideContentInLoading={true}
        hideActionAfterConfirm={true}
        size={'md'}
        onConfirm={handleConfirm}
        onClose={handleClose}>

        {isErrorSave && (
          <Alert key='error' variant='danger'>
            <b>Error:</b> {errorSaveMessage.current}
          </Alert>
        )}
        {isSuccessSave && (
          <Alert key='info' variant='success'>
            <b>Guardado Exitoso:</b> Se guardo la Revisión de la excepción.
          </Alert>
        )}
        {(!isErrorSave && !isSuccessSave) && (
          <>
            <div className='d-flex mx-n5'>
              <span className='me-2 fs-6'>Rechazar</span>
              <div dir="rtl" className="form-check form-switch">
                <input
                  id="flexSwitchCheckDefault"
                  className="form-check-input"
                  type="checkbox"
                  checked={isApproved}
                  role="switch"
                  onChange={(event) => {
                    setIsApproved(event.target.checked)
                  }}
                />
              </div>
              <span className='ms-0 fs-6'>Aprobar</span>
            </div>

          </>
        )}

      </ConfirmWithLoaderV2>
    </>
  )
}